import { IMapForecastScreen } from "campaign/model"
import { getCurrentFormCurrencyId } from "form/inventory/tools/common"
import { Feature, Point } from "geojson"
import { Popup } from "mapbox-gl"
import React from "react"
import ReactDOM from "react-dom"
import { isPhoneScreen } from "ui/tools/responsive"
import { ScreenDetails } from "../components/ScreenDetails"
import { INVENTORY_POPUP_ID } from "../model"
import { state } from "../state"

export function createInventoryMapPopupIfNeeded(): void {
  if (!state.inventory.popup) {
    state.inventory.popup = new Popup({
      closeButton: false,
      closeOnClick: false,
      maxWidth: "400"
    })
  }
}

export function closeInventoryMapPopup(): void {
  const popup = getInventoryMapPopup()
  if (!popup) {
    return
  }
  unMountPopupContent()
  popup.remove()
}

export function openInventoryScreenMapPopup(feature: Feature<Point, IMapForecastScreen>): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  const popup = getInventoryMapPopup()
  if (!popup) {
    console.warn("Inventory map popup is not available")
    return
  }
  const isPhone = isPhoneScreen()
  const minHeight = isPhone ? 7 : feature.properties.screen_count > 1 ? 4 : 7
  const minWidth = isPhone ? 7 : feature.properties.screen_count > 1 ? 23 : 15
  popup
    .setLngLat([feature.geometry.coordinates[0], feature.geometry.coordinates[1]])
    .setHTML(`<div id="${INVENTORY_POPUP_ID}" style="min-height: ${minHeight}rem;min-width: ${minWidth}rem;" />`)
    .addTo(map)
    .on("close", () => unMountPopupContent())
  ReactDOM.render(
    <ScreenDetails forecast={feature.properties} currencyId={getCurrentFormCurrencyId()} />,
    document.getElementById(INVENTORY_POPUP_ID)
  )
}

export function isInventoryMapPopupOpened(): boolean {
  const popup = getInventoryMapPopup()
  if (!popup) {
    return false
  }
  return popup.isOpen()
}

function getInventoryMapPopup(): Popup {
  return state.inventory.popup
}

function unMountPopupContent(): void {
  const container = document.getElementById(INVENTORY_POPUP_ID)
  if (container) {
    ReactDOM.unmountComponentAtNode(container)
  }
}
